import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";
import { openWhatsApp, WHATSAPP_MESSAGES } from "@/lib/whatsapp";

interface PageCTASectionProps {
  variant?: 'default' | 'accent';
}

const ctaLabels = {
  es: {
    title: "¿Listo para conocernos?",
    subtitle: "Da el siguiente paso y descubre cómo podemos acompañar a tu hijo/a en su aprendizaje.",
    bookVisit: "Reservar visita"
  },
  en: {
    title: "Ready to meet us?",
    subtitle: "Take the next step and discover how we can accompany your child in their learning journey.",
    bookVisit: "Book a visit"
  },
  pt: {
    title: "Pronto para nos conhecer?",
    subtitle: "Dê o próximo passo e descubra como podemos acompanhar seu filho/a na sua aprendizagem.",
    bookVisit: "Agendar visita"
  },
  fr: {
    title: "Prêt à nous rencontrer ?",
    subtitle: "Passez à l'étape suivante et découvrez comment nous pouvons accompagner votre enfant dans son apprentissage.",
    bookVisit: "Réserver une visite"
  }
};

export const PageCTASection = ({ variant = 'default' }: PageCTASectionProps) => {
  const { language } = useLanguage();
  const labels = ctaLabels[language];

  const handleBookVisit = () => {
    openWhatsApp(WHATSAPP_MESSAGES.bookVisit[language]);
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className={`py-16 px-4 rounded-2xl my-12 ${
        variant === 'accent' 
          ? 'bg-gradient-to-br from-accent/10 to-primary/10' 
          : 'bg-gradient-to-br from-primary/5 to-accent/5'
      }`}
    >
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-3xl font-light text-primary mb-4">
          {labels.title}
        </h2>
        <p className="text-lg text-muted-foreground mb-8">
          {labels.subtitle}
        </p>
        <div className="flex justify-center">
          <Button
            onClick={handleBookVisit}
            size="lg"
            className="bg-accent hover:bg-accent/90 text-accent-foreground shadow-lg hover:shadow-xl transition-all flex items-center gap-2"
          >
            <MessageCircle className="h-5 w-5" />
            {labels.bookVisit}
          </Button>
        </div>
      </div>
    </motion.section>
  );
};
